import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import { defaultNumberOfStreams } from '../../constants/streams.es.js';
import { RoyaltyCalculatorContext } from './RoyaltyCalculatorContext.es.js';

var RoyaltyCalculatorProvider = function RoyaltyCalculatorProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(defaultNumberOfStreams),
      _useState2 = _slicedToArray(_useState, 2),
      numberOfStreams = _useState2[0],
      setNumberOfStreams = _useState2[1];

  return (
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorContext.Provider, {
      value: {
        numberOfStreams: numberOfStreams,
        setNumberOfStreams: setNumberOfStreams
      }
    }, children)
  );
};

export { RoyaltyCalculatorProvider };